<script>
/* global $ */
import scrollToElement from '../../helpers/scroll-to-element';

export default {
  name: 'EcommerceListenAnchor',
  props: {
    scrolledToAnchor: {
      type: Boolean,
      default: false,
    },
    ecommerceHomePage: {
      type: Object,
      default: null,
    },
  },
  created() {
    const self = this;
    if (this.scrolledToAnchor && this.ecommerceHomePage) {
      setTimeout(() => {
        self.scrollToAnchor();
      }, 2000);
    }

    this.listenerButtonAnchor();
  },
  methods: {
    scrollToAnchor() {
      const $el = document.getElementById('form_ecom');
      const header = window.innerWidth < 580 ? document.querySelector('.mobile-header') : document.querySelector('.header-desktop');

      if ($el) {
        scrollToElement($el, header, 50);
      }

      // eslint-disable-next-line
      history.pushState('', document.title, window.location.pathname);
    },
    listenerButtonAnchor() {
      const self = this;

      $('a[href="#form_ecom"]').on('click', (e) => {
        e.preventDefault();
        if (self.ecommerceHomePage) {
          self.scrollToAnchor();
        } else {
          window.location.href = `${window.location.origin}/e-commerce#form_ecom`;
        }
      });
    },
  },
};

</script>
